var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	62423: {
		fallback: () => (() => (__webpack_require__(18260))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@paldesk/module-federation/core",

	},
	45698: {
		fallback: () => (() => (__webpack_require__(13551))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@paldesk/module-federation/remotes-registry",

	},
	40063: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9e396b"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(73393))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	49622: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_primitives_signals_angular_core_primitiv-a0f1dc"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(49460))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	23475: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9e396b"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(23620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	56658: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_primitives_signals_angular_core_primitiv-a0f1dc"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	30714: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-node_modules_ngrx_store_fesm2022_ngrx-store_mjs")]).then(() => (() => (__webpack_require__(81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	82754: {
		fallback: () => (Promise.all([__webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_primitives-signals_mjs")]).then(() => (() => (__webpack_require__(36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	96592: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(21352))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	56540: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(16613))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	46009: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(8072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	16628: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs").then(() => (() => (__webpack_require__(17415))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	15311: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(40784))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@core-features/core",

	},
	82139: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngrx_effects_fesm2022_ngrx-effects_mjs").then(() => (() => (__webpack_require__(70347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/effects",

	},
	84511: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(88176))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@core-features/bridge",

	},
	73870: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(72351))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/entity",

	},
	93142: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngrx_signals_fesm2022_ngrx-signals_mjs").then(() => (() => (__webpack_require__(61803))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals",

	},
	57463: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngrx_store-devtools_fesm2022_ngrx-store-devtools_mjs").then(() => (() => (__webpack_require__(11925))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store-devtools",

	},
	27288: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_paldesk_module-federation_shared_paldesk_module-feder-cb240c"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(1704))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@paldesk/module-federation/header",

	},
	53641: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(68596))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@utils/interceptors",

	},
	30712: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	11668: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_paldesk_module-federation_core_paldesk_module-federat-6a4597"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(61743))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@paldesk/module-federation/shared",

	},
	11886: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(72743))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/operators",

	},
	19382: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(8275))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals/rxjs-interop",

	},
	68884: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(45327))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/component-store",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [62423,45698];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"main": [
		62423,
		45698
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		40063
	],
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		49622
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		23475
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		56658
	],
	"default-webpack_sharing_consume_default_ngrx_store_ngrx_store": [
		30714
	],
	"default-webpack_sharing_consume_default_angular_core_primitives_signals_angular_core_primitiv-a0f1dc": [
		82754
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		96592
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		56540
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		46009
	],
	"default-libs_shared-lib_features_messenger_src_index_ts-libs_shared-lib_features_root-store_s-fb8dc6": [
		16628,
		15311,
		82139
	],
	"apps_service-inspection_src_bootstrap_ts": [
		84511,
		73870,
		93142,
		57463,
		27288,
		53641
	],
	"default-node_modules_angular_core_fesm2022__resource-chunk_mjs": [
		30712
	],
	"default-webpack_sharing_consume_default_paldesk_module-federation_shared_paldesk_module-feder-cb240c": [
		11668
	],
	"default-webpack_sharing_consume_default_paldesk_module-federation_core_paldesk_module-federat-6a4597": [
		62423
	],
	"default-webpack_sharing_consume_default_ngrx_operators_ngrx_operators-webpack_sharing_consume-ffbbd2": [
		11886,
		19382
	],
	"apps_service-inspection_src_app_inspection-process_inspection-process_routing_ts": [
		68884
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}